import "./style.css";
import layout from "./layout.html";
import { getScroll, getRaf, getInstance } from "@app";
import { clamp, map } from "@utils/math";
import works from "@data/works";
import { laptop } from "@app/breakpoints";

export default class Works {
  static selector = ".works";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
    this.items = block.querySelector(".works__items");
    this.itemsWrapper = block.querySelector(".works__items__wrapper");
    this.itemNodes = block.querySelectorAll(".works__items__wrapper__item");
    this.workTemplate = block.querySelector("#work-template");

    this.animations = {
      itemsTranform: {
        progress: 0,
        node: this.itemsWrapper,
        styles: {
          transform: {
            style: () => {
              const value =
                (this.maxOffset / 4) *
                this.animations.itemsTranform.styles.transform.current *
                -1;

              return `translate3d(${value}px, 0, 0)`;
            },
            dampingFactor: 0.09,
            toValue: 0,
            fromValue: 0,
            current: 0,
            setValue: () => {
              this.animations.itemsTranform.styles.transform.fromValue =
                this.animations.itemsTranform.styles.transform.fromValue +
                (this.animations.itemsTranform.styles.transform.toValue -
                  this.animations.itemsTranform.styles.transform.fromValue) *
                  this.animations.itemsTranform.styles.transform.dampingFactor;

              return this.animations.itemsTranform.styles.transform.fromValue;
            },
          },
        },
      },
    };
  }

  setupWork = (work) => {
    let workNode = this.workTemplate.content.firstElementChild.cloneNode(true);
    if (workNode) {
      let workImage = workNode.querySelector(
        ".works__items__wrapper__item__image"
      );
      workImage.style.backgroundImage = `url(${work.cover})`;

      let workTitle = workNode.querySelector(
        ".works__items__wrapper__item__title"
      );
      workTitle.textContent = work.title;

      return workNode;
    } else {
      return null;
    }
  };

  setupWorks = () => {
    return new Promise(async (resolve, reject) => {
      works.forEach((work, index) => {
        const workNode = this.setupWork(work);
        if (workNode) {
          this.itemsWrapper.appendChild(workNode);
        }
      });

      resolve();
    });
  };

  updateProgress = (scrollItem, scroll) => {
    const progress = clamp(map(scrollItem.progress, 0.02, 0.98, 0, 1), 0, 1);
    this.animations.itemsTranform.styles.transform.toValue = progress;
  };

  layout = () => {
    for (const key1 in this.animations) {
      for (const key2 in this.animations[key1].styles) {
        this.animations[key1].node.style[key2] =
          this.animations[key1].styles[key2].style();
      }
    }
  };

  render = () => {
    for (const key1 in this.animations) {
      for (const key2 in this.animations[key1].styles) {
        this.animations[key1].styles[key2].current =
          this.animations[key1].styles[key2].setValue();
      }
    }

    this.layout();
  };

  onReady = () => {
    return new Promise(async (resolve, reject) => {
      this.mounted = true;
      await this.setupWorks();
      await this.onResize();
      this.scroll = getScroll();
      this.scroll.register("works__items", this.updateProgress);

      if (!this.raf) {
        this.raf = getRaf();
        this.raf.register(this.block.dataset.instanceIndex, this.render);
      }

      resolve();
    });
  };

  onComplete = () => {
    return new Promise(async (resolve, reject) => {
      resolve();
    });
  };

  onResize = () => {
    return new Promise(async (resolve, reject) => {
      this.windowSizes = {
        width: window.innerWidth,
        height: window.innerHeight,
      };

      if (this.windowSizes.width >= laptop) {
        this.maxOffset = (this.items.scrollWidth - this.windowSizes.width) * 4;
        this.block.style.height = `${this.maxOffset}px`;
      }

      resolve();
    });
  };
}
